
<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard class='tablewrapper'>
            <CCardHeader>
              <div class="d-flex justify-content-between align-items-center">
                <CIcon name="cil-grid"/>
                <div class="card-header-actions">
                  <a
                    class="card-header-action"
                    rel="noreferrer noopener"
                    target="_blank"
                  >
                  </a>
                </div>
                <CButton size="md" color="info" @click="checkJob">Check Info</CButton>
              </div>
            </CCardHeader>
            <CCardBody>
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <a :class="prevTask == null ? 'disabled' : ''" :href="(prevTask == null) ? '' : ('/tasks/' + prevTask)" class="p-3"><img src="../assets/icons/left-icon.png" class="p-0"></a>
                  <a :class="nextTask == null ? 'disabled' : ''" :href="nextTask == null ? '' : ('/tasks/' + nextTask)" class="p-3"><img src="../assets/icons/right-icon.png" class="p-0"></a>
                </div>
                <div class="text-right mb-2">
                  <CButton v-if="!isNotPermitted" color="dark" variant="outline" square size="sm" @click="showConfirmModal()">全てを公開</CButton>
                </div>
              </div>
              <CDataTable
                :hover="true"
                :striped="true"
                :items="jobs"
                :loading="isLoading"
                :fields="fields"
                :tableFilter="false"
                :itemsPerPage="20"
                class='table-scroll text-center'
              >
                <template #is_org_public="{item}">
                  <td class="py-2">
                    <CBadge color="secondary" shape="pill" class='px-3 py-2' v-if='item.is_org_public'>{{orgPublicStates[item.is_org_public]}}</CBadge>
                    <CBadge color="danger" shape="pill" class='px-3 py-2' v-else>{{orgPublicStates[item.is_org_public]}}</CBadge>
                  </td>
                </template>

                <template #created_at="{item}">
                  <td class="py-2">
                    {{ formatDate(item.created_at)}}
                  </td>
                </template>

                <template #job_public_type="{item}">
                  <td class="py-2">
                    {{ publicTypeStates[item.job_public_type]}}
                  </td>
                </template>

                <template #name="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.name) }}
                  </td>
                </template>

                <template #address="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.address)}}
                  </td>
                </template>

                <template #capital="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.capital)}}
                  </td>
                </template>

                <template #description="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.description)}}
                  </td>
                </template>

                <template #employee_number="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.employee_number)}}
                  </td>
                </template>

                <template #work_employee_number="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.work_employee_number)}}
                  </td>
                </template>

                <template #established="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.established)}}
                  </td>
                </template>

                <template #working_style="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.working_style)}}
                  </td>
                </template>

                <template #job_description="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.job_description)}}
                  </td>
                </template>

                <template #working_address="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.working_address)}}
                  </td>
                </template>

                <template #salary="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.salary)}}
                  </td>
                </template>

                <template #holiday="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.holiday)}}
                  </td>
                </template>

                <template #feature="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.feature)}}
                  </td>
                </template>

                <template #edit_at="{item}">
                  <td class="py-2">
                    <span v-if='item.manage_status != "not_fix"'>
                      {{ formatDate2(item.updated_at)}}
                    </span>
                    <span v-else>
                      未編集
                    </span>
                  </td>
                </template>

                <template #knowledge_and_skills="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.knowledge_and_skills)}}
                  </td>
                </template>

                <template #multiple_application="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.multiple_application)}}
                  </td>
                </template>

                <template #access="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.access)}}
                  </td>
                </template>

                <template #recruitment_numbers_commute="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.recruitment_numbers_commute)}}
                  </td>
                </template>

                <template #recruitment_numbers_live_in="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.recruitment_numbers_live_in)}}
                  </td>
                </template>

                <template #recruitment_numbers_either="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.recruitment_numbers_either)}}
                  </td>
                </template>

                <template #job_class_one="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.job_class_one)}}
                  </td>
                </template>

                <template #job_class_one_change="{item}">
                  <td class="py-2">
                    {{ formatOmit(job_code_change[item.job_class_one]) }}
                  </td>
                </template>

                <template #job_class_two="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.job_class_two)}}
                  </td>
                </template>

                <template #job_number="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.job_number)}}
                  </td>
                </template>

                <template #corporate_number="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.corporate_number)}}
                  </td>
                </template>

                <template #office_number="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.office_number)}}
                  </td>
                </template>

                <template #working_address_postal_code="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.working_address_postal_code)}}
                  </td>
                </template>

                <template #working_address_access="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.working_address_access)}}
                  </td>
                </template>

                <template #industry_class="{item}">
                  <td class="py-2">
                    {{ formatOmit(item.industry_class)}}
                  </td>
                </template>

                <template #industry_class_change="{item}">
                  <td class="py-2">
                    {{ formatOmit(industry_code_change[item.industry_class]) }}
                  </td>
                </template>

                <template #manage_status="{item}">
                  <td class="py-2">
                    <CBadge color="info" shape="pill" class='px-3 py-2' v-if='item.manage_status == "fix" || item.manage_status == "edit"'>{{ manageStatusStates[item.manage_status] }}</CBadge>
                    <CBadge color="danger" shape="pill" class='px-3 py-2' v-else-if='item.manage_status == "not_parseable" || item.manage_status == "impossible"'>{{ manageStatusStates[item.manage_status] }}</CBadge>
                    <CBadge color="dark" shape="pill" class='px-3 py-2' v-else-if='item.manage_status == "already_exist"'>{{ manageStatusStates[item.manage_status] }}</CBadge>
                    <CBadge color="warning" shape="pill" class='px-3 py-2' v-else-if='item.manage_status == "auto_fix"'>{{ manageStatusStates[item.manage_status] }}</CBadge>
                    <CBadge color="primary" shape="pill" class='px-3 py-2' v-else>未修正</CBadge>
                  </td>
                </template>

                <template #show_details="{item}">
                  <td class="py-2">
                    <CButton v-if="!isNotPermitted" class="mr-2" color="danger" variant="outline" square size="sm" @click="showDeleteModal(item)">削除</CButton>
                    <CButton class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item)">編集</CButton>
                  </td>
                </template>
              </CDataTable>
            </CCardBody>
          </CCard>
      </CCol>
      <CCol sm="12" class="text-center">
        <paginate
          v-model="page"
          :page-count="meta.total_pages"
          :prev-text="'<'"
          :next-text="'>'"
          :first-last-button="true"
          :first-button-text="'<<'"
          :last-button-text="'>>'"
          :click-handler="paging"
          :container-class="'pagination'">
        </paginate>
      </CCol>
    </CRow>
    <job-modal @hide="hideRecordModal()" @update="updateInfo" :updateMode="currentMode" :record="record"  :recordModal="recordModal"></job-modal>
    <CModal
      title="まとめて公開しますか？？"
      color="dark"
      :show.sync="confirmModal"
    >
      <div class="text-center">
        <p>このインポートの求人を全て公開しますか？？</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideConfirmModal()">キャンセル</CButton>
        <CButton size="sm" color="primary" @click="publicateJob()">全て公開</CButton>
      </template>
    </CModal>
    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この求人を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>



  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import JobModal from "../components/JobModal";
import { mapGetters } from 'vuex';
import Paginate from 'vuejs-paginate'
import { Industry_code_dict, Job_code_dict } from '@/lib/data';
export default {
  name: 'Home',
  components: {Paginate, JobModal},
  data() {
    return {
      isLoading: false,
      recordModal: false,
      deleteModal: false,
      confirmModal: false,
      record: {},
      meta: {
        total_pages: 0
      },
      jobs: [],
      currentMode: "",
      task: {},
      orgPublicStates: {
        "true": "公開済み",
        "false": "未公開",
      },
      manageStatusStates: {
        "fix": "修正済",
        "not_fix": "未修正",
        "not_parseable": "解析不可",
        "already_exist": "登録済み",
        "edit": "修正済",
        "not": "未修正",
        "impossible": "解析不可",
        "auto_fix": "反映済"
      },
      publicTypeStates:{
        'designated' : '指定校推薦',
        'public' : '公開求人',
      },
      fields: [
        { key: 'task_id', label: "インポートID"},
        { key: 'id', label: "No"},
        { key: 'is_org_public', label: "求人票DataBox表示"},
        { key: 'created_at', label: "学校スキャン実施日"},
        { key: 'show_details', label: '',  _style: 'width:15%', sorter: false, filter: false},
        { key: 'edit_at', label: '修正日',  _style: 'width:15%', sorter: false, filter: false},
        { key: 'manage_status', label: '管理ステータス',  _style: 'width:15%', sorter: false, filter: false},
        { key: 'job_public_type', label: "求人形式"},
        { key: 'name', label: "企業名"},
        { key: 'name_kana', label: "事業所名フリガナ"},
        { key: 'job_number', label: "求人番号"},
        //{ key: 'name', label: "事業所名"},
        // { key: 'office_number', label: "事業所番号"},
        { key: 'postal_code', label: "所在地郵便番号"},
        { key: 'address', label: "所在地住所" },
        // { key: 'access', label: "所在地アクセス" },
        //{ key: 'corporate_number', label: "法人番号"},
        { key: 'employee_number', label: "従業員数（企業全体）"},
        { key: 'work_employee_number', label: "従業員数(就業場所)" },
        //{ key: 'established', label: "設立" },
        //{ key: 'capital', label: "資本金" },
        //{ key: 'description', label: "事業内容"},
        //{ key: 'feature', label: "会社の特徴"},
        //{ key: 'job_description', label: "仕事の内容"},
        //{ key: 'working_address_postal_code', label: "就業場所郵便番号" },
        { key: 'working_address', label: "就業場所住所"},
        //{ key: 'working_address_access', label: "就業場所アクセス"},
        { key: 'working_style', label: "職種"},
        { key: 'recruitment_numbers_commute', label: "求人数（通勤）" },
        { key: 'recruitment_numbers_live_in', label: "求人数（住込）" },
        { key: 'recruitment_numbers_either', label: "求人数（不問）" },
        { key: 'knowledge_and_skills', label: "必要な知識・技能等（履修科目）"},
        { key: 'salary', label: "毎月の賃金（月額）" },
        { key: 'holiday', label: "年間休日数"},
        { key: 'multiple_application', label: "複数応募" },
        //{ key: 'interview_venue_postal_code', label: "選考場所郵便番号" },
        //{ key: 'interview_venue', label: "選考場所住所"},
        //{ key: 'interview_venue_access', label: "選考場所アクセス"},
        //{ key: 'hr_contact_position', label: "担当者課係名役職名"},
        { key: 'hr_contact_name', label: "担当者氏名" },
        { key: 'industry_class', label: "産業分類（コード）" },
        { key: 'industry_class_change', label: "産業分類（大分類）" },
        { key: 'job_class_one', label: "職業分類（コード）" },
        { key: 'job_class_one_change', label: "職業分類（大分類）" },
        // { key: 'job_class_two', label: "職業分類二つ目（コード）" },
        { key: 'tel_number', label: "電話番号" },
        { key: 'fax_number', label: "FAX番号" },
        { key: 'harikennabi_url', label: "ハリケンナビURL" }
      ],
      industry_code_change: Industry_code_dict,
      job_code_change: Job_code_dict,
      nextTask: 0,
      prevTask: 0,
      taskIndex: null,
      task_id: '',
      jobs_check: [],
      school_id: 0
    }
  },
  methods: {
    formatDate(date){
      return moment(date).format("YYYY.MM.DD  HH:mm")
    },
    formatDate2(date){
      if(date == undefined){
        return '未編集'
      }
      else{
        return moment(date).format("YYYY.MM.DD HH:mm")
      }
    },
    hideDeleteModal() {
      this.deleteModal = false
    },
    deleteItem() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/api/mng/jobs/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.deleteModal = false
          this.fetchJobs()
        })
    },
    showDeleteModal(data) {
      this.record = data
      this.deleteModal = true

    },
    updateInfo(data){
      this.jobs.forEach((row, index) => {
        if(row.id == data.id){
          this.jobs[index] = data
        }
      })
      this.jobs.push(data)
      this.jobs.pop()
    },
    formatOmit(data){
      if(data != undefined || data != null){
        return data.length > 10 ? (data).slice(0,10)+"…" : data;
      }
      else{
        return ''
      }
    },
    showRecordModal(data) {
      this.recordModal = true
      this.record = Object.assign({}, data)
    },
    showConfirmModal() {
      this.confirmModal = true
    },
    hideConfirmModal() {
      this.confirmModal = false
    },
    publicateJob() {
      this.jobs.forEach((row) => {
        axios
          .patch(process.env.VUE_APP_API_ENDPOINT + "/api/mng/jobs/" + row.id, {"job": {"is_org_public": true}, "update_type": this.currentMode}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.notifyVue("更新されました")
            this.confirmModal = false

            this.fetchJobs()

          }).catch(error => {
            console.log(error)
          })

      })
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    fetchJobs: function(current_page = 1) {
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/task_queues/" + this.$route.params.id + "?per_page=20&page=" + current_page, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.jobs = response.data.jobs
            this.task = response.data.task
            this.meta.total_pages = response.data.meta.total_pages
            if(this.task.company_id == null) {
              this.currentMode = "job_school"
            } else {
              this.currentMode = "jobs"
            }
            this.jobs_check = []
            this.jobs.forEach(job => {
              job.task_id = response.data.task.id
              this.jobs_check.push({
                id: job.job_id,
                job_number: job.job_number,
                harikennabi_url: job.harikennabi_url
              })
              this.school_id = response.data.task.school_id
            })
        }).catch(error => {
            console.log(error)
        })
    },
    checkJob() {
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + "/api/mng/check_job_with_job_reference", {"jobs_check": this.jobs_check, "school_id": this.school_id}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.notifyVue("更新されました")
          this.confirmModal = false

          this.fetchJobs()

        }).catch(error => {
          console.log(error)
        })
    },
    paging: function (pageNum) {
      this.fetchJobs(pageNum)
    },
  },
  mounted() {
    this.fetchJobs();
    this.taskIndex = this.taskListId.split(",").map((x) => { 
      return x; 
    }).findIndex((e) => {
      return e == this.$route.params.id
    })
    this.nextTask = this.taskListId.split(",")[this.taskIndex + 1] ?? null
    this.prevTask = this.taskListId.split(",")[this.taskIndex - 1] ?? null
  },
  beforeMount() {
    this.$store.commit('setTaskListId', localStorage.getItem('task_list_id'))
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
      role: 'GetRole',
      taskListId: 'GetTaskListId',
    }),
    isNotPermitted() {
      return this.role == 'member'
    }
  },
}
</script>
<style scoped lang="scss">

.title-label, .title-value {
  font-size: 16px;
}

.tablewrapper{
  overflow-x: scroll;
}
.table-scroll{
  border-collapse: collapse;
  white-space: nowrap;
}
a.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.5;
}
</style>